// extracted by mini-css-extract-plugin
export default {"hello":"classes_hello__5ma7b"};